// URL directe des webhooks
const WEBHOOK_URL_CURRENT =
  "https://n8n.srv883693.hstgr.cloud/webhook/c1a2b68a-5634-4da4-af30-f5913801c364";

const WEBHOOK_URL_PREVIOUS =
  "https://n8n.srv883693.hstgr.cloud/webhook/c1a2b68a-5634-4da4-af30-f5913801c365";

const WEBHOOK_URL_ADDITIONAL =
  "https://n8n.srv883693.hstgr.cloud/webhook/c1a2b68a-5634-4da4-af30-f5913801c363";

// URL de l'API pour récupérer les données en cache
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin + '/api';
  }
  return '/api';
};

const API_BASE_URL = getApiBaseUrl();

/**
 * Service pour récupérer les statistiques des plateformes VTC
 */

/**
 * Fonction pour formater les montants
 */
const formatAmount = (value) => {
  if (value === null || value === undefined || value === 0) return "0,00 €";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "0,00 €";
  return num.toFixed(2).replace(".", ",") + " €";
};

/**
 * Formate les données en cache au format attendu par le dashboard
 */
const formatCachedDataAsStats = (cachedData) => {
  const normalizedData = {
    uber: {
      count: formatAmount(cachedData.uber || 0),
      percentage: "+0%",
      label: "Données en cache",
    },
    bolt: {
      count: formatAmount(cachedData.bolt || 0),
      percentage: "+0%",
      label: "Données en cache",
    },
    heetch: {
      count: formatAmount(cachedData.heetch || 0),
      percentage: "+0%",
      label: "Données en cache",
    },
    freenow: {
      count: formatAmount(cachedData.freenow || 0),
      percentage: "+0%",
      label: "Données en cache",
    },
    espece: {
      count: formatAmount(cachedData.espece || 0),
      percentage: "+0%",
      label: "Données en cache",
    },
  };

  return {
    success: true,
    data: normalizedData,
    vehicle: {
      marque: cachedData.marque || "",
      immat: cachedData.immat || "",
    },
    additional: null,
    niveauGlobal: cachedData.niveauGlobal || 0,
    isFromCache: true,
  };
};

/**
 * Récupère les statistiques en cache depuis l'API MongoDB
 * @param {object} user - Les données de l'utilisateur
 * @returns {Promise} - Les statistiques en cache avec pourcentages et labels
 */
export const getCachedStats = async (user) => {
  try {
    console.log("📦 Récupération des données en cache depuis l'API...");

    const response = await fetch(`${API_BASE_URL}/stats/get`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: user.email,
        first_name: user.first_name,
        role: user.role,
        transco: user.transco,
      }),
    });

    if (!response.ok) {
      console.log("⚠️ Pas de données en cache disponibles");
      return null;
    }

    const result = await response.json();

    if (result.success && result.hasCachedData) {
      console.log("✅ Données en cache récupérées:", result.data);
      // Retourner les données avec statsFormatted si disponibles
      return {
        ...result.data,
        statsFormatted: result.data.statsFormatted || null,
      };
    }

    return null;
  } catch (error) {
    console.error("❌ Erreur lors de la récupération du cache:", error);
    return null;
  }
};

/**
 * Récupère les statistiques pour un utilisateur
 * @param {object} user - Les données de l'utilisateur (email, first_name, role, etc.)
 * @param {boolean} skipCache - Si true, ne pas utiliser le cache et appeler directement les webhooks
 * @returns {Promise} - Les statistiques des plateformes
 */
export const getVTCStats = async (user, skipCache = false) => {
  try {
    console.log("📊 Récupération des statistiques VTC pour:", user);

    // 1. D'abord, essayer de récupérer les données en cache (sauf si skipCache = true)
    let cachedData = null;
    if (!skipCache) {
      cachedData = await getCachedStats(user);
    }

    const requestData = {
      action: "get_stats",
      email: user.email,
      first_name: user.first_name,
      role: user.role,
      transco: user.transco,
    };

    console.log("📤 Données envoyées au webhook:", requestData);

    // 2. Appeler les trois webhooks en parallèle
    const [responseCurrent, responsePrevious, responseAdditional] = await Promise.all([
      fetch(WEBHOOK_URL_CURRENT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      }),
      fetch(WEBHOOK_URL_PREVIOUS, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      }),
      fetch(WEBHOOK_URL_ADDITIONAL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      }),
    ]);

    if (!responseCurrent.ok || !responsePrevious.ok) {
      // Si les webhooks échouent mais qu'on a des données en cache, les utiliser
      if (cachedData) {
        console.log("⚠️ Webhooks échoués, utilisation des données en cache");
        return formatCachedDataAsStats(cachedData);
      }
      throw new Error("Erreur lors de la récupération des statistiques");
    }

    const dataCurrent = await responseCurrent.json();
    const dataPrevious = await responsePrevious.json();
    const dataAdditional = responseAdditional.ok ? await responseAdditional.json() : null;

    console.log("✅ Statistiques actuelles:", dataCurrent);
    console.log("✅ Statistiques semaine précédente:", dataPrevious);
    console.log("✅ Données additionnelles (c363):", dataAdditional);

    if (dataCurrent) {
      // Fonction pour calculer le pourcentage de différence
      const calculatePercentage = (current, previous) => {
        const curr = typeof current === "string" ? parseFloat(current) : current;
        const prev = typeof previous === "string" ? parseFloat(previous) : previous;

        if (!curr || !prev || prev === 0) return "+0%";

        const diff = ((curr - prev) / prev) * 100;
        const sign = diff >= 0 ? "+" : "";
        return `${sign}${diff.toFixed(0)}%`;
      };

      // Normaliser les données avec calcul de pourcentage
      const normalizedData = {
        uber: {
          count: formatAmount(dataCurrent.UBER || dataCurrent.uber || 0),
          percentage: calculatePercentage(
            dataCurrent.UBER || dataCurrent.uber,
            dataPrevious.UBER || dataPrevious.uber
          ),
          label: "vs semaine dernière",
        },

        bolt: {
          count: formatAmount(dataCurrent.BOLT || dataCurrent.bolt || 0),
          percentage: calculatePercentage(
            dataCurrent.BOLT || dataCurrent.bolt,
            dataPrevious.BOLT || dataPrevious.bolt
          ),
          label: "vs semaine dernière",
        },

        heetch: {
          count: formatAmount(dataCurrent.HEETCH || dataCurrent.heetch || 0),
          percentage: calculatePercentage(
            dataCurrent.HEETCH || dataCurrent.heetch,
            dataPrevious.HEETCH || dataPrevious.heetch
          ),
          label: "vs semaine dernière",
        },

        freenow: {
          count: formatAmount(dataCurrent.FREENOW || dataCurrent.freenow || 0),
          percentage: calculatePercentage(
            dataCurrent.FREENOW || dataCurrent.freenow,
            dataPrevious.FREENOW || dataPrevious.freenow
          ),
          label: "vs semaine dernière",
        },

        espece: {
          count: formatAmount(dataCurrent.ESPECES || dataCurrent.ESPECE || dataCurrent.espece || 0),
          percentage: calculatePercentage(
            dataCurrent.ESPECES || dataCurrent.ESPECE || dataCurrent.espece,
            dataPrevious.ESPECES || dataPrevious.ESPECE || dataPrevious.espece
          ),
          label: "vs semaine dernière",
        },
      };

      console.log("📊 Données normalisées:", normalizedData);

      // Ajouter les données du véhicule
      const vehicleData = {
        marque: dataCurrent.marque || dataCurrent.MARQUE || "",
        immat: dataCurrent.immat || dataCurrent.IMMAT || "",
      };

      // Extraire le niveau global
      const niveauGlobal = dataCurrent.niveauglobal || dataCurrent.NIVEAUGLOBAL || 0;

      // Fusionner les données financières avec les données additionnelles pour le cache
      const mergedAdditionalCache = {
        ...dataAdditional,
        FormuleTI: dataCurrent.FormuleTI,
        GesteC: dataCurrent.GesteC,
        caution: dataCurrent.caution,
        STATUT: dataCurrent.STATUT || dataCurrent.statut,
        Contrav: dataCurrent.Contrav,
        solldeinterieur: dataCurrent.solldeinterieur || dataCurrent.soldeinterieur,
        AvanceCarburant: dataCurrent.AvanceCarburant,
      };

      // Enregistrer les stats dans MongoDB pour le cache (avec les pourcentages et labels)
      try {
        await fetch(`${API_BASE_URL}/stats/save`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: user.email,
            first_name: user.first_name,
            // Valeurs brutes
            uber: dataCurrent.UBER || dataCurrent.uber || 0,
            bolt: dataCurrent.BOLT || dataCurrent.bolt || 0,
            heetch: dataCurrent.HEETCH || dataCurrent.heetch || 0,
            freenow: dataCurrent.FREENOW || dataCurrent.freenow || 0,
            espece: dataCurrent.ESPECES || dataCurrent.ESPECE || dataCurrent.espece || 0,
            // Données complètes avec pourcentages
            statsFormatted: normalizedData,
            marque: vehicleData.marque,
            immat: vehicleData.immat,
            niveauGlobal: niveauGlobal,
            additional: mergedAdditionalCache,
          }),
        });
        console.log("💾 Statistiques enregistrées dans le cache");
      } catch (error) {
        console.error("⚠️ Erreur lors de l'enregistrement du cache:", error);
        // Ne pas bloquer si l'enregistrement échoue
      }

      // Fusionner les données financières avec les données additionnelles
      const mergedAdditional = {
        ...dataAdditional,
        // Ajouter les données financières de dataCurrent
        FormuleTI: dataCurrent.FormuleTI,
        GesteC: dataCurrent.GesteC,
        caution: dataCurrent.caution,
        STATUT: dataCurrent.STATUT || dataCurrent.statut,
        Contrav: dataCurrent.Contrav,
        solldeinterieur: dataCurrent.solldeinterieur || dataCurrent.soldeinterieur,
        AvanceCarburant: dataCurrent.AvanceCarburant,
      };

      // Préparer les données de la semaine précédente pour la comparaison
      const previousWeekStats = {
        uber: dataPrevious.UBER || dataPrevious.uber || 0,
        bolt: dataPrevious.BOLT || dataPrevious.bolt || 0,
        heetch: dataPrevious.HEETCH || dataPrevious.heetch || 0,
        freenow: dataPrevious.FREENOW || dataPrevious.freenow || 0,
        espece: dataPrevious.ESPECES || dataPrevious.ESPECE || dataPrevious.espece || 0,
      };

      return {
        success: true,
        data: normalizedData,
        vehicle: vehicleData,
        additional: mergedAdditional,
        niveauGlobal: niveauGlobal,
        previousWeekStats: previousWeekStats,
      };
    }

    return {
      success: false,
      data: null,
    };
  } catch (error) {
    console.error("❌ Erreur lors de la récupération des statistiques:", error);

    // Message plus explicite pour l'utilisateur
    let messageErreur = "Erreur lors de la récupération des données";

    if (error.message.includes("Workflow was started")) {
      messageErreur =
        "Traitement en cours. Vérifiez le workflow n8n pour les résultats.";
    } else if (
      error.message.includes("CORS") ||
      error.message.includes("NetworkError")
    ) {
      messageErreur =
        "Erreur de connexion au serveur. Vérifiez votre connexion internet.";
    }

    console.error("📋 Message d'erreur:", messageErreur);

    // Retourner des données par défaut en cas d'erreur
    return {
      success: false,
      data: {
        uber: { count: "0,00 €", percentage: "+0%", label: "Non disponible" },
        bolt: { count: "0,00 €", percentage: "+0%", label: "Non disponible" },
        heetch: { count: "0,00 €", percentage: "+0%", label: "Non disponible" },
        freenow: { count: "0,00 €", percentage: "+0%", label: "Non disponible" },
        espece: { count: "0,00 €", percentage: "+0%", label: "Non disponible" },
      },
    };
  }
};

/**
 * Format attendu de la réponse du webhook :
 * {
 *   uber: {
 *     count: 281,
 *     percentage: "+55%",
 *     label: "que la semaine dernière"
 *   },
 *   bolt: {
 *     count: "2,300",
 *     percentage: "+3%",
 *     label: "que le mois dernier"
 *   },
 *   heetch: {
 *     count: "34k",
 *     percentage: "+1%",
 *     label: "qu'hier"
 *   },
 *   freenow: {
 *     count: "+91",
 *     percentage: "",
 *     label: "Mis à jour"
 *   }
 * }
 */

export default {
  getVTCStats,
  getCachedStats,
};
